import { apiFetch } from '../../../shared/services/apiClient';
import { ActividadEconomica } from '../types';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:4000/api';

export const actividadesService = {
  async listar(): Promise<ActividadEconomica[]> {
    const res = await apiFetch(`${API_BASE}/actividades-economicas`);
    if (!res.ok) throw new Error('Error cargando actividades económicas');
    return res.json();
  },
};
